import React, {useEffect, useRef, useState} from "react";

interface ComparingChartProps {
    children: React.ReactNode
    className?: string
}

export default function ComparingChart({children, className}: ComparingChartProps) {
    const scrollRef = useRef<HTMLTableElement>(null);
    const [shadowClass, setShadowClass] = useState("");

    const scrollShadow = () => {
        if (scrollRef.current) {
            const scrollElement = scrollRef.current;
            const {scrollWidth, clientWidth, scrollLeft} = scrollElement;
            const containerWidth = scrollElement.offsetWidth;
            if (scrollWidth > containerWidth) {
                if (scrollLeft === 0) {
                    setShadowClass("shadow-right");
                } else if (scrollLeft + clientWidth < scrollWidth) {
                    setShadowClass("shadow-left shadow-right");
                } else {
                    setShadowClass("shadow-left");
                }
            } else {
                setShadowClass("");
            }
        }
    };

    useEffect(() => {
        scrollShadow();
    }, []);

    return (
        <div className={`comparing-chart ${shadowClass}`}>
            <div ref={scrollRef} onScroll={scrollShadow} className={`comparing-chart-table-container ${className ?? ''}`}>
                <table className={'comparing-chart-table'}>
                    {children}
                </table>
            </div>
        </div>
    )
}
